import axios from "axios";
import { API_URL } from "./api-url.config";
import { getCookie } from "./helpers";

/**
 * Payment API Setup
 */
export const API = axios.create({
  baseURL: API_URL,
});

console.log(API_URL);

// REQUEST
API.interceptors.request.use(
  async (config) => {
    const hashCookie = getCookie("hash");
    // Only set the header if we have a token
    if (hashCookie) {
      // Ensure headers object exists
      config.headers = config.headers ?? {};
      // @ts-ignore (Axios v1 uses AxiosHeaders; this is fine at runtime)
      config.headers.Authorization = `Bearer ${hashCookie}`;
    }
    return config;
  },
  (error) => {
    console.error(`[request error] [${JSON.stringify(error)}]`);
    return Promise.reject(error);
  },
);

// RESPONSE
const MAX_RETRIES = 3;
const BASE_DELAY_MS = 300; // backoff base

function sleep(ms) {
  return new Promise((res) => setTimeout(res, ms));
}

API.interceptors.response.use(
  // Success passthrough
  (response) => response,

  // Error handler
  async (error) => {
    const originalRequest = error.config || {};
    const resDataPath = error.response?.data?.path;
    const isMobileOperator =
      resDataPath === "/payment/api/v2/pgw/gpdcb/subscription" ||
      resDataPath === "/payment/api/v2/pgw/bldcb/subscription" ||
      resDataPath === "/payment/api/v2/pgw/robi_dsdb/subscription";

    // Special-case 400 for subscription path: resolve with the server response
    if (error.response?.status === 400 && isMobileOperator) {
      // If you want callers to handle this in "then", keep resolve:
      return Promise.resolve(error.response);
      // If you prefer callers to catch it, do: return Promise.reject(error);
    }

    const status = error.response?.status;

    // Initialize retry counter
    originalRequest._retryCount = originalRequest._retryCount ?? 0;

    // Example retry policy: retry on 401/403/5xx, up to MAX_RETRIES
    const retriable =
      (status === 401 || status === 403 || (status ?? 0) >= 500) &&
      originalRequest._retryCount < MAX_RETRIES;

    if (retriable) {
      originalRequest._retryCount += 1;

      // Optional: if you have a refresh flow, do it here for 401/403:
      // await refreshAuthIfNeeded();

      // Exponential backoff: 300ms, 600ms, 1200ms...
      const delay =
        BASE_DELAY_MS * Math.pow(2, originalRequest._retryCount - 1);
      console.log(
        `Retrying ${originalRequest.url} (attempt ${originalRequest._retryCount}/${MAX_RETRIES}) after ${delay}ms`,
      );
      await sleep(delay);

      return API(originalRequest);
    }

    // Out of retries or not retriable → reject
    return Promise.reject(error);
  },
);

/**
 * Payment API Setup
 */
export const ContentAPI = axios.create({
  baseURL: API_URL,
});

// Add a request interceptor
ContentAPI.interceptors.request.use(
  async (config) => {
    const hashCookie = getCookie("hash");
    config.headers.Authorization = `Bearer ${hashCookie}`;
    return config;
  },
  (error) => {
    console.error(`[request error] [${JSON.stringify(error)}]`);
    return Promise.reject(error);
  },
);

ContentAPI.interceptors.response.use(
  // Successful responses
  (response) => {
    // You can process the response data here
    return response;
  },
  // Error responses
  async (error) => {
    // You can handle errors here
    const originalRequest = error.config;

    const status = error.response?.status;

    // Initialize retry counter
    originalRequest._retryCount = originalRequest._retryCount ?? 0;

    // Example retry policy: retry on 401/403/5xx, up to MAX_RETRIES
    const retriable =
      (status === 401 || status === 403 || (status ?? 0) >= 500) &&
      originalRequest._retryCount < MAX_RETRIES;

    if (retriable) {
      originalRequest._retryCount += 1;

      // Optional: if you have a refresh flow, do it here for 401/403:
      // await refreshAuthIfNeeded();

      // Exponential backoff: 300ms, 600ms, 1200ms...
      const delay =
        BASE_DELAY_MS * Math.pow(2, originalRequest._retryCount - 1);
      console.log(
        `Retrying ${originalRequest.url} (attempt ${originalRequest._retryCount}/${MAX_RETRIES}) after ${delay}ms`,
      );
      await sleep(delay);

      return API(originalRequest);
    }

    // Out of retries or not retriable → reject
    return Promise.reject(error);
  },
);
